import Box from "@mui/material/Box";
import {ReactComponent as BackIcon} from "../../Icons/back.svg";
import {compositionMediaThumbnailNavButtonSx} from "../../composition/compositionMediaLayoutSx";

export const CAROUSEL_NAV_ICON_COLOR = "#3B8BEC";
export const CAROUSEL_TRANSITION_MS = 1000;

const carouselNavIconBaseSx = {
    display: "block",
    flexShrink: 0,
    "& path": {
        stroke: CAROUSEL_NAV_ICON_COLOR,
    },
};

export const CarouselNavIcon = ({rotate, iconSx}) => (
    <Box
        component={BackIcon}
        sx={{
            ...carouselNavIconBaseSx,
            ...iconSx,
            ...(rotate ? {transform: rotate} : {}),
        }}
    />
);

export const carouselNavButtonBaseSx = {
    ...compositionMediaThumbnailNavButtonSx,
    position: "relative",
    top: "auto",
    left: "auto",
    transform: "none",
    margin: "0 8px",
};

export const bannerNavButtonSx = {
    ...carouselNavButtonBaseSx,
    opacity: "1 !important",
    "&:hover": {
        backgroundColor: "#FFFFFF",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.18)",
        opacity: "1 !important",
    },
};

export const kitchenNavButtonSx = {
    ...carouselNavButtonBaseSx,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    padding: 0,
    cursor: "pointer",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    opacity: "0.55 !important",
    "&:hover": {
        cursor: "pointer",
        backgroundColor: "rgba(255, 255, 255, 0.75)",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.18)",
        opacity: "0.85 !important",
    },
};

export const bannerIndicatorIconSx = {
    width: 100,
    height: 4,
    borderRadius: "2px",
    "& svg": {
        display: "none",
    },
    "&:hover": {
        backgroundColor: (theme) => theme.palette.primary.light,
    },
    backgroundColor: (theme) => theme.palette.primary.stroke,
};

export const bannerActiveIndicatorIconSx = {
    width: 100,
    height: 4,
    borderRadius: "2px",
    "& svg": {
        display: "none",
    },
    "&:hover": {
        backgroundColor: (theme) => theme.palette.primary.light,
    },
    backgroundColor: (theme) => theme.palette.primary.dark,
};
